import '../../scss/sections/header.scss';
import initHeaderMegaMenu from 'JsComponents/header-mega-menu.js';
import initHeaderMobileDrawer from 'JsComponents/header-mobile-drawer.js';
import initHeaderSearch from 'JsComponents/header-search.js';

let megaMenu = null;
let mobileDrawer = null;
let headerSearch = null;

function init() {
    if (megaMenu) megaMenu.destroy();
    if (mobileDrawer) mobileDrawer.destroy();
    if (headerSearch) headerSearch.destroy();
    megaMenu = initHeaderMegaMenu();
    mobileDrawer = initHeaderMobileDrawer();
    headerSearch = initHeaderSearch();
}

// Guard for already-parsed DOM (bundle can execute after DOMContentLoaded fires).
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

// Re-init on theme editor section reload — only when a header-group section reloads.
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.header-wrapper-new, .burger-drawer, [data-header-search]')) init();
});
